import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { UploadFile } from 'ng-zorro-antd';
import { Observer, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { UserModel } from 'src/app/model/UserModel';
import { AccountService } from 'src/app/services/account.service';
 

@Component({
  selector: 'app-kycupld',
  templateUrl: './kycupld.component.html',
  styleUrls: ['./kycupld.component.css']
})
export class KycupldComponent implements OnInit {

  KycStatus:string ="Pending"
  uploading = false;
  fileList1: UploadFile[] = [];
  fileList2: UploadFile[] = [];
  isLoadingOne = false;
  statusColor:string ="Blue";
  statusText:string ="";
  @Output() public onUploadFinished = new EventEmitter();
  currentUser : UserModel;

  public progress: number;
  public message: string;
  constructor(private toastrService:ToastrService, private formBuilder: FormBuilder, private http:HttpClient, 
    private authenticationService: AuthenticationService, private accountService :AccountService) { 

      this.currentUser = this.authenticationService.getCurrentUser();
      if(  this.currentUser)
    {
       this.KycStatus = this.currentUser.KycStatus;
       this.statusText =  this.KycStatus;

       if(this.KycStatus.toLowerCase() === "Rejected".toLowerCase() || this.KycStatus.toLowerCase() === "No Kyc".toLowerCase())
       {
         this.statusColor='red';
       }
       if(this.KycStatus.toLowerCase() === "Pending".toLowerCase() )
       {
        this.statusColor='purple';
       }
       if(this.KycStatus.toLowerCase() === "Approved".toLowerCase() )
       {
        this.statusColor='green';
       }
      }
       
    }

  ngOnInit() {
  }

  public uploadKYCFiles = async () => {
     if (this.fileList1.length === 0 || this.fileList2.length==0 ) {
       this.toastrService.error("Please select ID and Utility files to upload");
       return;
     }
  
     this.isLoadingOne = true;
     let KyCFile :any =           this.fileList1[0];
     let UtilityBill :any =           this.fileList2[0];
     let i_customer : string= this.currentUser.i_Customer;
     let OperratorCode : number= this.currentUser.OperatorID;
     
     
     //var KYCFileName:string= 
     const formData = new FormData();
     formData.append('KYCfile', KyCFile, KyCFile.name);
     formData.append('UtilityBill', UtilityBill, UtilityBill.name);
     formData.append('i_customer',i_customer+"");

     formData.append('customerClassName',"Individual");
     formData.append('OperatorID',OperratorCode+"");
     formData.append('customerKYCStatus',1+"");
     formData.append('uploadSource',"SelfCare");
     
      var uploadur :string= `${environment.lteHttpBaseUrl}/api/v1/uploadkyc`;
  
    let ret = await this.http.post<any>(uploadur, formData).toPromise();
    if(ret.Status==0)
    {
      this.isLoadingOne = false;
      this.toastrService.info(ret.Message);

    }
    else
    {

      this.message = 'Upload successful.';
      this.toastrService.info("KYC Uploaded succesful");
    //  this.onUploadFinished.emit(event.body);
      this.isLoadingOne = false;
 
  this.isLoadingOne = false;
  this.fileList1.pop();
  this.fileList2.pop();

  this.currentUser .KycStatus="Pending";
  

  let suspendresult =  this.accountService.UnblockAccount(i_customer).toPromise();
  console.log(suspendresult);
  localStorage.setItem("currentUser",JSON.stringify(this.currentUser ));


    }
    console.log(ret);

      
      /* .subscribe(event => {
         if (event.type === HttpEventType.UploadProgress)
           this.progress = Math.round(100 * event.loaded / event.total);
         else if (event.type === HttpEventType.Response) 
         {
           if(event.===0 )
           {
         
            this.toastrService.info(event.body.Message);

           }
           else
           {

            debugger;
            this.message = 'Upload successful.';
            this.toastrService.info("KYC Uploaded succesful");
            this.onUploadFinished.emit(event.body);
            this.isLoadingOne = false;
 
 
 
        this.toastrService.info("KYC Uploaded succesful");
        this.isLoadingOne = false;
        this.fileList1.pop();
        this.fileList2.pop();
 
        this.currentUser .KycStatus="Pending";
        debugger;
 
        let suspendresult =  this.accountService.UnblockAccount(i_customer).toPromise();
        console.log(suspendresult);
        localStorage.setItem("currentUser",JSON.stringify(this.currentUser ));
           }
      


       console.log(event);
         }*/
     
     //  });

   

       
   }

  beforeUpload1 = (file: UploadFile) => {

    return new Observable((observer: Observer<boolean>) => {
      const isImage = file.type.startsWith('image');

      if (isImage) 
      {
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
          this.toastrService.error('file must be smaller than 3MB!');
          observer.complete();
          return;
        }
 
        if(this.fileList1.length==1)
        {

          this.toastrService.error('One document allowed!');

          return;

        }
        this.fileList1 = this.fileList1.concat(file);
        observer.next(false);
        observer.complete();



      } else {
        this.toastrService.error('You can only upload image file');
        observer.complete();
        return;
      }

    });
  }
  
  beforeUpload2 = (file: UploadFile) => {

    return new Observable((observer: Observer<boolean>) => {
      const isImage = file.type.startsWith('image');

      if (isImage) {
        const isLt3M = file.size / 1024 / 1024 < 3;
        if (!isLt3M) {
          this.toastrService.error('file must be smaller than 3MB!');
          observer.complete();
          return;
        }

        if(this.fileList2.length==1)
        {

          this.toastrService.error('One document allowed!');

          return;

        }


        this.fileList2 = this.fileList2.concat(file);
        observer.next(false);
        observer.complete();



      } else {
        this.toastrService.error('You can only upload image file');
        observer.complete();
        return;
      }

    });
  }





}
